import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import PreDoc from './pre-doc';
import { getHistoryParamList, getParamList as _getParamList } from '@/api/correspondence/task/form';
import { transformParamsToFormV2 } from '@/components/common/transformData';
import toPreviewData from '@/views/correspondence/task/components/util/preview-data';
export default {
  name: 'popover-pre-doc',
  components: {
    PreDoc: PreDoc
  },
  props: {
    confirmId: {
      default: function _default() {
        return undefined;
      }
    },
    history: {
      default: function _default() {
        return false;
      }
    },
    loadingList: {
      default: function _default() {
        return [];
      }
    },
    taskId: {
      default: function _default() {
        return undefined;
      }
    },
    inTable: {
      default: function _default() {
        return false;
      }
    },
    sysParams: {
      default: function _default() {
        return {};
      }
    },
    size: {
      type: String,
      default: function _default() {
        return '70%';
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '预览';
      }
    },
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    html: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  computed: {
    _sysParams: function _sysParams() {
      return this.sysParams;
    },
    previewHtml: function previewHtml() {
      if (this.inTable) {
        return this.html;
      }
      return this.previewData;
    }
  },
  data: function data() {
    return {
      drawer: false,
      list: [],
      previewData: '',
      loading: false
    };
  },
  watch: {
    sysParams: function sysParams(value) {
      this.toPreViewData(this.content, true);
    },
    content: function content(value) {
      if (this.content !== value) {
        this.toPreViewData(value, true);
      }
    }
  },
  methods: {
    toPreViewData: function toPreViewData(value) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.previewData = toPreviewData(value, this.list, this._sysParams);
      if (!update) {
        this.$emit('data', this.previewData);
      }
    },
    getParamList: function getParamList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var options, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, res, data, html;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!_this.loadingList.includes(_this.confirmId)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this.$emit('loadingList', _this.confirmId);
              if (!(_this.list.length === 0 && _this.confirmId && !_this.loading)) {
                _context.n = 4;
                break;
              }
              _this.loading = true;
              // this.$emit('loading',true)
              options = {
                PageNumber: 1,
                PageSize: 9999,
                SearchQuery: ''
              };
              _context.n = 2;
              return _this.$awaitTo(_this.history ? getHistoryParamList(_this.confirmId, _this.taskId, options) : _getParamList(_this.confirmId, _this.taskId, options));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              res = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              // this.$emit('loading',false)
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2, Promise.reject());
            case 3:
              data = res.data;
              if (Array.isArray(data)) {
                _this.list = data.map(function (params) {
                  return transformParamsToFormV2(params);
                });
              }
            case 4:
              if (!_this.inTable) {
                _this.toPreViewData(_this.content);
              } else {
                html = toPreviewData(_this.content, _this.list, _this._sysParams);
                _this.$emit('data', html);
              }
              return _context.a(2, Promise.resolve(_this.list));
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.getParamList();
  }
};